import { render, staticRenderFns } from "./ZoomSelectionVG.vue?vue&type=template&id=2824461e"
import script from "./ZoomSelectionVG.vue?vue&type=script&lang=js"
export * from "./ZoomSelectionVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports